import { StylesConfig } from "react-select";

const borderColor = '#EBEBEB';
const primaryColor = '#EC068D';
const softPrimary = '#FFF9FD';
const textDarkGray = '#555E6D';
const pearl = '#FFEBF7';

const baseControlStyles = (styles: any, width: string, fontSize = '14px') => ({
    ...styles,
    color: textDarkGray,
    borderRadius: '8px',
    borderColor: borderColor,
    fontSize: fontSize,
    width,
    height: '40px',
    overflowY: 'auto',
    boxShadow: 'unset',
    ':hover': {
        ...styles[':hover'],
        borderColor: borderColor,
    },
});

const baseOptionStyles = (styles: any, { isDisabled, isFocused, isSelected }: any, hasSelectedStyle: boolean = false) => ({
    ...styles,
    backgroundColor: isDisabled
        ? undefined
        : isSelected && hasSelectedStyle
            ? pearl
            : isFocused
                ? softPrimary
                : undefined,
    color: isDisabled
        ? '#ccc'
        : isSelected && hasSelectedStyle
            ? primaryColor
            : textDarkGray,
});

export const selectCreateColourStyles: StylesConfig = {
    control: (styles) => baseControlStyles(styles, '300px', '16px'),
    option: (styles, { isDisabled, isFocused, isSelected }) =>
        baseOptionStyles(styles, { isDisabled, isFocused, isSelected }, true),
};

export const selectSummarizeColourStyles: StylesConfig = {
    control: (styles) => baseControlStyles(styles, '100%', '16px'),
    option: (styles, { isDisabled, isFocused, isSelected }) =>
        baseOptionStyles(styles, { isDisabled, isFocused, isSelected }, true),
};